import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import EinsteinHeaderIcon from '../../static/img/einstein-header-icon.svg';

import './EinsteinCard.scss';

class EinsteinCard extends Component {
  render() {
    return (
      <div className="einstein-card einstein-bg">
        <h1>{this.props.title}</h1>
        <p>{this.props.info}</p>
        <img
          className="einstein-icon"
          src={EinsteinHeaderIcon}
          alt="Einstein"
        />
      </div>
    );
  }
}

EinsteinCard.propTypes = {
  title: PropTypes.string,
  info: PropTypes.string,
  location: PropTypes.object
};

export default injectIntl(EinsteinCard);
